import copy from "../../data/free_extras_copy.json" with { type: "json" };

export const FREE_EXTRAS_COPY = Object.freeze(copy);

export function validFreeExtrasGift(gift) {
  if (!gift || !Number.isFinite(gift.startsAt) || !Number.isFinite(gift.endsAt)
    || gift.startsAt <= 0 || gift.endsAt <= gift.startsAt) return null;
  return gift;
}

export function formatFreeExtrasDate(timestamp, locale) {
  if (!Number.isFinite(timestamp) || timestamp <= 0) return "";
  return new Intl.DateTimeFormat(locale, {
    year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", timeZoneName: "short",
  }).format(new Date(timestamp * 1000));
}


export function subscriptionForGiftDisplay(subscription, gift) {
  // Reconciliation retains expired rows but sets their plan to Free. Paid rows
  // remain authoritative for current coverage, including provider grace periods.
  if (validFreeExtrasGift(gift) && subscription?.planCode === "free") return null;
  return subscription || null;
}
